"use client";

import dynamic from "next/dynamic";
import Link from "@/components/link";

import googlePlayAnimation from "../resources/lottie/google-play.json";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

export default function GooglePlay(props) {
  return (
    <Link
      href="https://play.google.com/store/apps/details?id=com.studyiq.android&hl=en_IN&gl=US"
      target="_blank"
      {...props}
    >
      <Lottie
        animationData={googlePlayAnimation}
        initialSegment={[0, 90]}
        loop={false}
      />
    </Link>
  );
}
